import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, vShow as _vShow, createTextVNode as _createTextVNode, renderList as _renderList } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/x-circle.svg'


const _hoisted_1 = { class: "grid gap-6 grid-cols-6" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-black-lp-300 mt-1"
}
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = { class: "text-20px font-semibold" }
const _hoisted_5 = { class: "text-20px font-semibold" }
const _hoisted_6 = { class: "w-40" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_8 = { class: "flex items-end justify-between" }
const _hoisted_9 = { class: "flex gap-x-12" }
const _hoisted_10 = { class: "space-y-2" }
const _hoisted_11 = { class: "font-semibold text-black-lp-300" }
const _hoisted_12 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_13 = { class: "space-y-2" }
const _hoisted_14 = { class: "font-semibold text-black-lp-300" }
const _hoisted_15 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_16 = { class: "space-y-2" }
const _hoisted_17 = { class: "font-semibold text-black-lp-300" }
const _hoisted_18 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_19 = { class: "space-y-2" }
const _hoisted_20 = { class: "font-semibold text-black-lp-300" }
const _hoisted_21 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_22 = { class: "flex gap-x-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_24 = { class: "relative" }
const _hoisted_25 = { class: "flex-col grid col-gap-2 grid-cols-8 justify-center w-full mt-2" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "col-span-2" }, null, -1)
const _hoisted_27 = { class: "col-span-4 space-y-1" }
const _hoisted_28 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "check circle"
}, null, -1)
const _hoisted_30 = { class: "text-12px text-black-lp-300" }
const _hoisted_31 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "x circle"
}, null, -1)
const _hoisted_33 = { class: "text-12px text-black-lp-300" }
const _hoisted_34 = {
  class: "font-semibold text-black-lp-300",
  style: {"width":"20rem"}
}
const _hoisted_35 = { class: "font-normal mt-2" }
const _hoisted_36 = { class: "flex flex-row" }
const _hoisted_37 = { class: "w-5/12" }
const _hoisted_38 = { class: "w-7/12" }
const _hoisted_39 = { class: "flex flex-row" }
const _hoisted_40 = { class: "w-5/12" }
const _hoisted_41 = { class: "w-7/12" }
const _hoisted_42 = { class: "flex flex-row" }
const _hoisted_43 = { class: "w-5/12" }
const _hoisted_44 = { class: "w-7/12" }
const _hoisted_45 = { class: "flex flex-row" }
const _hoisted_46 = { class: "flex flex-col space-y-3" }
const _hoisted_47 = { class: "text-20px font-semibold text-black-lp-200" }
const _hoisted_48 = { class: "space-y-1" }
const _hoisted_49 = { class: "text-12px xxl:text-14px text-gray-lp-600 pr-12" }
const _hoisted_50 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_51 = { class: "text-gray-lp-600 text-12px xxl:text-14px" }
const _hoisted_52 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 mr-2",
  alt: "check circle"
}, null, -1)
const _hoisted_53 = { class: "text-gray-lp-300 text-12px xxl:text-14px" }
const _hoisted_54 = { class: "flex justify-end space-x-3" }
const _hoisted_55 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardToastNeedAccess = _resolveComponent("DashboardToastNeedAccess")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Print = _resolveComponent("Print")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.$t('sti.updateButton'),
      "vertical-separator": false,
      "is-floating-action": true,
      fullPage: ""
    }, {
      "top-right": _withCtx(() => [
        (_ctx.dataProfile.countryCode !== 'my')
          ? (_openBlock(), _createBlock(_component_DashboardToastNeedAccess, {
              key: 0,
              title: _ctx.$t('Perlu di STI'),
              "end-key": _ctx.dashboardDetailData?.endKey,
              "last-status": _ctx.dashboardDetailData?.lastStatus,
              status: "sti"
            }, null, 8, ["title", "end-key", "last-status"]))
          : _createCommentVNode("", true)
      ]),
      data: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            class: "col-span-2",
            label: _ctx.$t('Nama Partner')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                disabled: "",
                modelValue: _ctx.partnerName
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "col-span-2",
            label: _ctx.$t('Tipe User')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                disabled: "",
                modelValue: _ctx.userType
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "col-span-2",
            label: _ctx.$t('Tanggal STI')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Datepicker, {
                class: "mt-1.5",
                disabled: "",
                modelValue: _ctx.form.pickupDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.pickupDate = $event)),
                placeholder: _ctx.$t('sti.datePlaceholder')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "col-span-4",
            label: _ctx.$t('No. STT/ID Manifest')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                ref: "inputStt",
                sizeInput: "24px",
                onEnter: _ctx.onValidateSttNumber,
                onChange: _ctx.onChangeInputStt,
                labelStacked: 
              _ctx.$t(
                'Contoh : No. STT : 99LP1234567890123/88-22-12345678 atau ID Manifest : PUM00000'
              )
            ,
                modelValue: _ctx.form.sttNumber,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.sttNumber = $event)),
                bold: !!_ctx.form.sttNumber,
                placeholder: 
              _ctx.$t('Masukan No. STT/ID Manifest atau Scan Barcode/QR Code')
            
              }, null, 8, ["onEnter", "onChange", "labelStacked", "modelValue", "bold", "placeholder"]),
              (!_ctx.isPaid)
                ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(_ctx.$t(
                "*Terjadi kelebihan berat sehingga customers perlu menyelesaikan tagihan kurang bayar",
                { isIdManifest: _ctx.isIdManifest ? "pada beberapa STT" : "" }
              )), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.sttNumberTypeStatus)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                class: "col-span-2 flex flex-row items-center justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_3, [
                    _createVNode("img", {
                      src: 
                require(`@/app/ui/assets/svg/${_ctx.sttNumberTypeStatus.icon}.svg`)
              ,
                      class: "w-20 mr-3",
                      alt: "number type of status"
                    }, null, 8, ["src"]),
                    _createVNode("div", {
                      class: 
                `${_ctx.sttNumberTypeStatus.color} ${
                  _ctx.isSti && !_ctx.isStiDest ? 'rounded-full' : 'rounded-2xl'
                } text-green-lp-400 flex flex-col px-6 py-4`
              
                    }, [
                      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.sttNumberTypeStatus.title), 1),
                      _withDirectives(_createVNode("div", _hoisted_5, null, 512), [
                        [_directive_sanitize_html, _ctx.sttNumberTypeStatus.message]
                      ])
                    ], 2)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_LpButton, {
            onClick: _ctx.addSttNumber,
            customClass: "px-12 py-2.5",
            title: _ctx.$t('Tambah'),
            textColor: "white",
            disabled: _ctx.isDisableAddSttNumber
          }, null, 8, ["onClick", "title", "disabled"])
        ]),
        (_ctx.dataSttToBeUpdate.length)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_7,
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("Total STT")), 1),
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.totalStt), 1)
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("Total Koli")), 1),
                    _createVNode("div", _hoisted_15, _toDisplayString(_ctx.totalPieces), 1)
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("Total Gross Weight")), 1),
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.formatWeight(_ctx.totalGrossWeight)), 1)
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("Total Volume Weight")), 1),
                    _createVNode("div", _hoisted_21, _toDisplayString(_ctx.formatWeight(_ctx.totalVolumeWeight)), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode(_component_LpButton, {
                    outline: "",
                    iconLeft: "delete",
                    onClick: _ctx.onShowDelete,
                    title: _ctx.$t('Hapus'),
                    textColor: "red-lp-300"
                  }, null, 8, ["onClick", "title"]),
                  _createVNode(_component_LpButton, {
                    onClick: _ctx.togglePanel,
                    icon: 
                _ctx.$refs.op?.visible ? 'chevron-up-white' : 'chevron-down-white'
              ,
                    title: _ctx.$t('Process'),
                    textColor: "white"
                  }, null, 8, ["onClick", "icon", "title"]),
                  _createVNode(_component_OverlayPanel, {
                    ref: "op",
                    appendTo: "body",
                    style: {"width":"auto"},
                    class: "absolute"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LpButton, {
                        class: "w-60",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pickupAndPrint(false))),
                        flat: "",
                        dense: "",
                        iconLeft: "sti",
                        title: _ctx.$t('sti.updateButton')
                      }, null, 8, ["title"]),
                      _hoisted_23,
                      _createVNode(_component_LpButton, {
                        class: "w-60",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pickupAndPrint(true))),
                        flat: "",
                        dense: "",
                        iconLeft: "printer",
                        title: _ctx.$t('Update STI & Print PDF')
                      }, null, 8, ["title"])
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _createVNode("div", _hoisted_24, [
                _createVNode(_component_TableV2, {
                  data: _ctx.dataSttToBeUpdate,
                  columns: _ctx.columns,
                  borderTop: false,
                  pagination: _ctx.pagination,
                  "is-hard-pagination": true,
                  "is-quick-search": true,
                  "is-sorting": true,
                  "pagination-style": "v2"
                }, null, 8, ["data", "columns", "pagination"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack", "title"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onDownload : _ctx.alertPopup.onClick
    ,
      onClose: _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onClick : () => {},
      title: _ctx.alertPopup.title,
      message: _ctx.alertPopup.message,
      image: _ctx.alertPopup.image,
      textSuccess: _ctx.isPartial || _ctx.isFailed ? 'Download' : 'OK',
      textCancel: _ctx.isPartial || _ctx.isFailed ? 'OK' : '',
      class: "px-8",
      customButton: _ctx.isPartial || _ctx.isFailed ? 'px-10' : 'px-6'
    }, {
      custom: _withCtx(() => [
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode("div", _hoisted_27, [
            _withDirectives(_createVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode("div", _hoisted_30, _toDisplayString(this.form.totalSuccess) + " " + _toDisplayString(_ctx.$t("No. STT Sukses")), 1)
            ], 512), [
              [_vShow, _ctx.isPartial]
            ]),
            _withDirectives(_createVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode("div", _hoisted_33, _toDisplayString(this.form.totalFailed) + " " + _toDisplayString(_ctx.$t("No. STT Gagal")), 1)
            ], 512), [
              [_vShow, _ctx.isPartial || _ctx.isFailed]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel", "customButton"]), [
      [_vShow, _ctx.isResponseUpdate]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('Yakin ingin keluar?'),
      message: 
      _ctx.$t(
        'Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.'
      )
    ,
      image: "are-you-sure",
      textSuccess: _ctx.$t('Keluar'),
      textCancel: _ctx.$t('Kembali'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationLeave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: _ctx.handleConfirmationSave,
      title: _ctx.$t('customStatus.confirmUpdateTitle'),
      message: 
      _ctx.$t('Pastikan kembali, seluruh detail STT sudah benar dan sesuai.')
    ,
      image: "are-you-sure",
      textSuccess: _ctx.$t('Process'),
      textCancel: _ctx.$t('Batal'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationSave]
    ]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.notification = $event)),
      hasChild: _ctx.isIdManifest,
      data: _ctx.detailSttNotification
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_34, [
          _createTextVNode(_toDisplayString(_ctx.$t("Input ID Manifest Berhasil -")) + _toDisplayString(this.form.idManifest) + " ", 1),
          _createVNode("div", _hoisted_35, [
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("No. ID Manifest")), 1),
              _createVNode("div", _hoisted_38, ": " + _toDisplayString(this.form.idManifest), 1)
            ]),
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("Total STT")), 1),
              _createVNode("div", _hoisted_41, ": " + _toDisplayString(this.form.totalStt), 1)
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("Total Koli")), 1),
              _createVNode("div", _hoisted_44, ": " + _toDisplayString(this.form.totalPieces), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "hasChild", "data"]),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.showDeleteSttNumber,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDeleteSttNumber = $event)),
      persistent: true,
      onReset: _ctx.onCloseDelete
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_45, [
          _createVNode("img", {
            src: 
          require(`@/app/ui/assets/svg/${
            _ctx.sttNumberSuccessDelete ? 'delete-success' : 'delete-confirm'
          }.svg`)
        ,
            class: "w-40 mr-12",
            alt: "update status"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("Hapus Barang")), 1),
            _createVNode("div", _hoisted_48, [
              _withDirectives(_createVNode("div", _hoisted_49, null, 512), [
                [_directive_sanitize_html, 
              _ctx.$t(
                'Masukan No. STT atau Scan Barcode/QR Code</br>untuk barang yang ingin dihapus dari daftar STI.'
              )
            ]
              ]),
              _createVNode(_component_LpInput, {
                ref: "deleteStt",
                error: !!_ctx.errorSttNumberDelete,
                errorCaption: _ctx.errorSttNumberDelete,
                onEnter: _ctx.onValidateDeleteSttNumber,
                modelValue: _ctx.sttNumberToDelete,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.sttNumberToDelete = $event))
              }, null, 8, ["error", "errorCaption", "onEnter", "modelValue"])
            ]),
            (_ctx.sttNumberListTrash.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_50, [
                  _createVNode("div", _hoisted_51, _toDisplayString(_ctx.$t("Terhapus")), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttNumberListTrash, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "flex flex-row",
                      key: item
                    }, [
                      _hoisted_52,
                      _createVNode("div", _hoisted_53, _toDisplayString(item), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_54, [
          _createVNode(_component_LpButton, {
            onClick: _ctx.onCloseDelete,
            customClass: "px-10 py-2",
            textColor: "red-lp-100",
            outline: "",
            title: _ctx.$t('Batal'),
            class: "mt-10"
          }, null, 8, ["onClick", "title"]),
          _createVNode(_component_LpButton, {
            disabled: !_ctx.sttNumberToDelete,
            onClick: _ctx.onDeleteSttNumber,
            customClass: "px-10 py-2",
            textColor: "white",
            title: _ctx.$t('Hapus'),
            class: "mt-10"
          }, null, 8, ["disabled", "onClick", "title"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onReset"]),
    _createVNode("div", _hoisted_55, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ], 64))
}